<template>
    <div v-if="transactionLine" class="flex items-center gap-1" :data-cy="`attachments-transaction-${params.data.transactionUuid}`">
        <template v-if="attachments?.length">
            <template v-if="attachments.length <= 5">
                <UBadge
                    v-for="(attUuid, counter) in attachments"
                    :key="attUuid"
                    :class="[
                        isHoverToOpenDocumentPreviewModal ? 'cursor-zoom-in' : 'cursor-pointer'
                    ]"
                    :variant="attUuid === selectedDocumentMetaUuid ? 'solid' : 'outline'"
                    color="primary"
                    @click="onClickDocumentLink(attUuid)"
                    @mouseover="onHoverDocumentLink(attUuid)"
                >
                    {{ counter + 1 }}
                </UBadge>
            </template>
            <transaction-link v-else :transaction-uuid="transactionLine.transactionUuid">
                <UBadge
                    variant="outline"
                    color="primary"
                    class="cursor-pointer"
                >
                    {{ attachments.length }} vedlegg
                </UBadge>
            </transaction-link>
        </template>
    </div>
</template>

<script setup lang="ts">

import {TransactionLine} from '@/types/transaction/TransactionLine'
import {computed, provide} from 'vue'
import {useDocumentPreviewModalService} from '@/transaction-journal/DocumentPreview.modal.service'
import TransactionLink from '@/transaction/TransactionLink.vue'

const {onClickDocumentLink, onHoverDocumentLink, isHoverToOpenDocumentPreviewModal, selectedDocumentMetaUuid} = useDocumentPreviewModalService()
const props = defineProps({
    params: {
        type: Object as () => {
            data: TransactionLine,
            context: any
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const transactionLine = computed(() => {
    return props.params.data
})

const attachments = computed(() => {
    return transactionLine.value.documentMetaUuids
})

</script>

<style scoped>

</style>